<template>
    <div class="price price-list mb-2" :class="{
        'selected': price.time == selectedPackage
    }">
        <label
            :class="{
                    'bg-gray-100 border-light': price.time !== selectedPackage,
            }"
            :for="price.time"
            class="d-block float-none cursor-pointer font-size-2 m-0"
        >
            <div class="d-flex align-items-center">
                <div>
                    <b-form-radio
                        :id="price.time"
                        v-model="selectedPackage"
                        :value="price.time"
                        name="packages"
                        @input="$emit('input', selectedPackage)"
                    /> 
                </div>
                <b-row cols="12" align-content="center" :style="{width: '100%'}">
                        <b-col cols="12" :lg="modal ? 6 : 5" :xl="modal ? 5:3" order="2" order-lg="1">
                            <h3 class="font-weight-normal textAlign l">
                                {{ price.planName }}
                            </h3>
                        </b-col>
                        <b-col cols="12" :lg="modal ? 3 : 2" :xl="modal ? 5:2" order="1" order-lg="2" class="d-flex justify-content-center justify-content-lg-start">
                            <b-badge
                                v-if="price.badge === 'MOST POPULAR'"
                                class="ml-2 align-content-center"
                                pill
                                variant="info"
                            >
                                Most Popular
                            </b-badge>

                            <b-badge
                                v-if="price.badge === 'BEST VALUE'"
                                class="ml-2 align-content-center"
                                pill
                                variant="success"
                            >
                                Best Protection
                            </b-badge>
                        </b-col>
                        <b-col cols="12" lg="6" order="3" order-lg="4">
                            <p class="mb-0 desc textAlign l">
                                {{ price.time }} and {{ price.legalHours | currency('$', 0) }} in legal protection.
                            </p>
                        </b-col>
                        <b-col cols="12" :lg="modal ? 3 : 5" :xl="modal ? 2:7" order="4" order-lg="3">
                            <div class="priceText textAlign r">
                                {{ localPrice.payNowPrice | currency('$', 0) }}
                            </div>
                        </b-col>
                        <b-col cols="12" lg="6" order="5">
                            <div class="subtext textAlign r">
                                Or {{ localPrice.payAtClose | currency('$', 0) }} at closing
                            </div>
                        </b-col>
                    </b-row>
            </div>
        </label>
    </div>
</template>

<script>
import "./Price.scss";
import {replaceAll} from "@helpers/string";

const customInput = {
    props: ['price', 'name'],
    template: `
        <input
            :value="price"
            :name="name"
            class="testPrice"
            type="text"
        />
    `
}
export default {
    name: 'Price',
    components: {
        customInput: customInput
    },
    props: {
        price: {
            type: Object,
        },
        value: {
            type: String
        },
        modal:{
            type: Boolean
        }
    },
    data: () => ({
        selectedPackage: null,
        localPrice: {},
    }),
    methods: {
        getName() {
            return this.price.timeInt + ' Year Protection Package';
        },
        getSnakeName(text) {
            let name = replaceAll(this.getName().toLowerCase().replace(' protection package', ''),' ', '_');
            return text + '_' + name;
        },
        changePackage(priceLocal = null, from = '') {
            if (from === 'pnow') {
                this.localPrice.payNowPrice = priceLocal;
            }
            if (from === 'pac') {
                this.localPrice.payAtClose = priceLocal;
            }
        },
    },
    watch: {
        value: {
            immediate: true,
            handler() {
                this.selectedPackage = this.value;
                this.localPrice = this.price;
            }
        }
    }
}
</script>